import type ImageType from "@travily/types/shared/Image";
import { Avatar, type AvatarColor, type AvatarShape, type AvatarSize } from "@ui/components/Avatar";
import type { ReactNode } from "react";

const ACCOUNT_TYPE_COLORS: Record<string, AvatarColor> = {
  Family: "red",
  Individual: "purple",
  Community: "yellow",
  Personal: "gray",
};

function getProfileTypeColor(profileType: string): AvatarColor {
  return ACCOUNT_TYPE_COLORS[profileType] ?? "red";
}

interface AccountAvatarAccount {
  profile_type: string;
  avatar?: ImageType | null;
  initial?: string | null;
}

export interface AccountAvatarProps {
  account: AccountAvatarAccount;
  children?: ReactNode;
  className?: string;
  shape?: AvatarShape;
  size?: AvatarSize;
}

export function AccountAvatar({ account, children, className, shape, size }: AccountAvatarProps) {
  return (
    <Avatar.Root
      className={className}
      color={getProfileTypeColor(account.profile_type)}
      image={account.avatar}
      initial={account.initial}
      shape={shape}
      size={size}
    >
      {children}
    </Avatar.Root>
  );
}
